import { useQuery } from '@tanstack/react-query';

import { useUrlChecker } from '@/hooks/useUrlChecker';
import { getUser } from './getUser';

export const useUser = () => {
  const { isPublic } = useUrlChecker();
  const { data: user } = useQuery({
    queryKey: ['user'],
    queryFn: () => getUser(),
    staleTime: Infinity,
    enabled: !isPublic,
  });

  return { isPublic, user };
};
